/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ContextUpgradeable__factory } from "./ContextUpgradeable__factory";
